class ActionProvider {
  constructor(createChatBotMessage, setStateFunc) {
    this.createChatBotMessage = createChatBotMessage;
    this.setState = setStateFunc;
  }

  async handleFeatureQuery(message) {
    const loadingMsg = this.createChatBotMessage(
      'Let me think... 🤔 Keep in mind this is PoC so I will spend a minute or two to search for the answer'
    );
    this.setState((prev) => ({
      ...prev,
      messages: [...prev.messages, loadingMsg],
    }));

    const typingId = `typing-${Date.now()}`;
    const typingMsg = this.createChatBotMessage('...', { loading: true });
    typingMsg.id = typingId;

    this.setState((prev) => ({
      ...prev,
      messages: [...prev.messages, typingMsg],
    }));

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/getAIsuggestion`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ featureDescription: message }),
        }
      );

      const data = await response.json();
      const replyMsg = this.createChatBotMessage(
        data.summary || 'No relevant tests found.'
      );

      // Replace typing with AI reply
      this.setState((prev) => ({
        ...prev,
        messages: [...prev.messages.filter((m) => m.id !== typingId), replyMsg],
      }));
    } catch (error) {
      const errorMsg = this.createChatBotMessage(
        'Error talking to AI service.'
      );
      this.setState((prev) => ({
        ...prev,
        messages: [...prev.messages.filter((m) => m.id !== typingId), errorMsg],
      }));
    }
  }
}

export default ActionProvider;
